/**
 * Format a number using the Indian numbering system (lakhs, crores).
 * e.g. 2674884 → "26,74,884"
 */
export function formatNumber(n) {
  if (n === null || n === undefined) return "0";
  return Number(n).toLocaleString("en-IN");
}
